export default __webpack_public_path__ + "book_details-isbn10.39ad8135.png";